import { OauthService } from "../services"
import { ActionContext, Module } from 'vuex'
import { RootState, CustomPages } from '../store/state_models'

export const customPages: Module<CustomPages, RootState> ={
    namespaced: true,
    state: {
        customPages: [] as any,
        locationId: undefined as string | undefined,
    },
    getters: {
      get(state: any) {
        return state.customPages
      }
    },
    actions: {
      fetch(context: ActionContext<CustomPages, RootState>, data:{companyId:string, locationId?: string}) {
        return new Promise(async (resolve, reject) => {
          try {
            if (context.state.locationId === data.locationId && context.state.customPages?.length) {
                return resolve(context.state.customPages)
            }
            const customPages = await OauthService.getCustomPages(data.companyId, data.locationId)              
            context.commit('add', {customPages, locationId:data.locationId})
            return resolve(customPages)
          } catch {
            reject()
          }
        })
      }
    },
    mutations: {
      add: (state: CustomPages, payload: any) => {
        state.customPages = payload.customPages
        state.locationId = payload?.locationId
      },
      remove: (state: CustomPages) => {
        state.customPages = []
        state.locationId = undefined
      }
    }
  }